<section class="signup-container" [class.height-sidebar-content]="!hasGlobalMessages()"
  [class.height-sidebar-content-global-message]="hasGlobalMessages()">
  <div class="signup" id="scroll-to-top-ref">

    <div class="signup__header animated fadeInDown">
      <div class="container my-3">
        <a routerLink="/shop">
          <img class="signup__logo" src="/assets/images/logo-main.svg?v={{logoVersionNumber()}}" alt="Philly Foodworks">
        </a>
      </div>
    </div>

    @if (isLoadingContent() || accountService.isLoading()) {
    <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
    }

    @if (signupPromotionInfo()?.code && signupPromotionInfo()?.name) {
    <div class="alert position-sticky top-0 alert-success border-0 z-1020 fade show animated fadeInUp rounded-0"
      [class.animated]="!isTryingToApplyCoupon()" role="alert">
      <div class="d-flex justify-content-center align-items-center gap-3">

        @if (signupPromotionInfo()?.code && signupPromotionInfo()?.name) {
        <section
          class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
          <section class="d-flex align-items-center gap-2 justify-content-center">
            <i class="fas fa-tag"></i>
            <strong>Discount successfully applied!</strong>
          </section>
          <section class="d-flex align-items-center gap-2 justify-content-center">
            <i class="fw-semibold">({{signupPromotionInfo().code}})</i>
            {{signupPromotionInfo().name}}
          </section>
          <!-- <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
            (click)="clearSignupPromotionInfo()" ngbTooltip="Change Coupon Code">
            <i class="fas fa-sync"></i>
            <a href="javascript:void(0)" class="link-color">
              Change Coupon
            </a>
          </section> -->
        </section>
        } @else {
        <section
          class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
          <section class="d-flex align-items-center gap-2 justify-content-center">
            <i class="fas fa-tag"></i>
            <strong class="text-nowrap">Have a coupon? Apply it here:</strong>
          </section>
          <section class="d-flex align-items-center gap-3">
            <input type="text" class="form-control form-control-sm" placeholder="Coupon Code" #signupCouponCode
              (keyup.enter)="applySignupCoupon(signupCouponCode.value)">

            <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
              (click)="applySignupCoupon(signupCouponCode.value)">
              <i class="fas fa-check"></i>
              <a href="javascript:void(0)" class="link-color">
                Apply
              </a>
            </section>

            @if (signupPromotionInfoFromLS()?.code && signupPromotionInfoFromLS()?.name) {
            or

            <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
              (click)="restoreSignupInfo()">
              <i class="fas fa-times"></i>
              <a href="javascript:void(0)" class="link-color">
                Cancel
              </a>
            </section>

            }
          </section>
        </section>
        }

      </div>
    </div>
    }

    <div class="signup__body animated fadeInUp">
      <h1 class="signup__head-text">Set Up Your New Account</h1>
      <div class="container">
        <mat-stepper [linear]="true" #stepper class="animated fadeIn" [disableRipple]="true">


          <mat-step #firstStep [completed]="(
              this.hasDeliveryAddressCoverage() &&
              !!this.selectedDeliveryDay()) &&
              (
                (
                  this.selectedDeliveryDay()?.allowTimeWindow &&
                  !!this.selectedDeliveryTimeWindow()
                ) ||
                !this.selectedDeliveryDay()?.allowTimeWindow
              )" [editable]="false" label="Delivery Address">
            <ng-template matStepperIcon="edit">
              1
            </ng-template>
            <div>
              <form>

                <app-check-address-signup (out_deliveryAddress)="this.deliveryAddress.set($event)"
                  (out_hasDeliveryAddressCoverage)="this.hasDeliveryAddressCoverage.set($event)"
                  (out_isGoogleAddressFilled)="this.isGoogleAddressFilled.set($event)"
                  [isCheckContinue]="isCheckContinue()">
                </app-check-address-signup>

                <!-- TODO: Review hydratation error when using "@if" to avoid the rendering of this div -->
                @if (isGoogleAddressFilled() && hasDeliveryAddressCoverage()) {
                <div class="row form-row animated fadeInDown">
                  <div class="col-md-6">
                    <h6 class="signup__sub-head-text">When should we deliver your order?</h6>
                    <mat-form-field class="w-100" [class.option-selected]="!!selectedDeliveryDay()">
                      <mat-label>* Choose a day</mat-label>
                      <mat-select name="selectedDeliveryDay" [value]="selectedDeliveryDay()?.id || null"
                        (selectionChange)="setSelectedDeliveryDay($event)">
                        @for (item of deliveryOptions; track $index) {
                        <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (isCheckContinue() && !selectedDeliveryDay()) {
                    <div class="invalid-feedback d-block">
                      <i class="fas fa-xmark"></i>
                      This field is required
                    </div>
                    }
                  </div>
                  <div class="col-md-6 d-flex align-items-end">
                    @if (selectedDeliveryDay()) {
                    @if (selectedDeliveryDay()?.allowTimeWindow) {
                    <mat-form-field class="w-100 animated fadeInLeft"
                      [class.option-selected]="!!selectedDeliveryTimeWindow()">
                      <mat-label>* Choose a time window</mat-label>
                      <mat-select name="selectedDeliveryTimeWindow" [value]="selectedDeliveryTimeWindow() || null"
                        (selectionChange)="selectedDeliveryTimeWindow.set($event.value)">
                        @for (item of timeSet(); track $index) {
                        <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                      </mat-select>
                      @if (isCheckContinue() && !selectedDeliveryTimeWindow()) {
                      <div class="invalid-feedback d-block">
                        <i class="fas fa-xmark"></i>
                        This field is required
                      </div>
                      }
                    </mat-form-field>
                    } @else {
                    <mat-form-field class="w-100 animated fadeInLeft">
                      <mat-label>Time window</mat-label>
                      <input type="text" matInput readonly="true" name="selectedDeliveryTimeWindow"
                        [value]="selectedDeliveryDay()?.timeSet?.[0]?.name">
                    </mat-form-field>
                    }
                    }
                  </div>
                </div>

                <div class="form-row-action ">
                  <button type="button" (click)="validateDeliveryAddress()" class="btn btn-primary animated fadeIn">
                    Continue
                  </button>
                </div>
                }
              </form>
            </div>
          </mat-step>

          <mat-step #secondStep [completed]="isValidFormPersonalInformation() && firstStep.completed" [editable]="false"
            label="Personal Information">
            @if (!!personalInformation()) {
            <div class="container animated fadeIn">
              <form class="needs-validation">

                <div class="row form-row mt-5">
                  <!-- First Name -->
                  <div class="col-md-4">
                    <div class="form-floating has-validation">
                      <input placeholder type="text" class="form-control"
                        [class.is-invalid]="!personalInformationValidations.get('firstName')?.()?.valid"
                        name="firstNameCtrl" [ngModel]="personalInformation()?.firstName"
                        (blur)="validatePersonalInfoField('firstName', $event)"
                        (ngModelChange)="updatePersonalInformation({firstName: $event }, 'firstName')" />
                      <label for="firstNameCtrl">* First Name</label>
                      @if (!personalInformationValidations.get('firstName')?.()?.valid) {
                      @for (error of personalInformationValidations.get('firstName')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                  <!-- Last Name -->
                  <div class="col-md-4">
                    <div class="form-floating">
                      <input placeholder type="text" class="form-control" name="lastNameCtrl"
                        [class.is-invalid]="!personalInformationValidations.get('lastName')?.()?.valid"
                        [ngModel]="personalInformation()?.lastName"
                        (blur)="validatePersonalInfoField('lastName', $event)"
                        (ngModelChange)="updatePersonalInformation({lastName: $event }, 'lastName')" />
                      <label for="lastNameCtrl">* Last Name</label>
                      @if (!personalInformationValidations.get('lastName')?.()?.valid) {
                      @for (error of personalInformationValidations.get('lastName')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                  <!-- Phone -->
                  <div class="col-md-4">
                    <div class="form-floating">
                      <input placeholder type="text" class="form-control" maxlength="10" name="phoneCtrl" appOnlyNumber
                        [class.is-invalid]="!personalInformationValidations.get('phone')?.()?.valid"
                        [ngModel]="personalInformation()?.phone" (blur)="validatePersonalInfoField('phone', $event)"
                        (ngModelChange)="updatePersonalInformation({phone: $event }, 'phone')" />
                      <label for="phoneCtrl">* Phone</label>
                      @if (!personalInformationValidations.get('phone')?.()?.valid) {
                      @for (error of personalInformationValidations.get('phone')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                </div>

                <div class="row form-row">
                  <!-- Email -->
                  <div class="col-md-6">
                    <div class="form-floating">
                      <input placeholder type="email" class="form-control" name="emailCtrl"
                        [class.is-invalid]="!personalInformationValidations.get('email')?.()?.valid"
                        [ngModel]="personalInformation()?.email" (blur)="validatePersonalInfoField('email', $event)"
                        (ngModelChange)="updatePersonalInformation({email: $event }, 'email')" />
                      <label for="emailCtrl">* Email</label>
                      @if (!personalInformationValidations.get('email')?.()?.valid) {
                      @for (error of personalInformationValidations.get('email')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                  <!-- Password -->
                  <div class="col-md-6">
                    <div class="form-floating has-validation">
                      <mat-form-field subscriptSizing="dynamic" class="w-100">
                        <mat-label>* Password</mat-label>
                        <input placeholder type="password" class="form-control form-control-password" matInput
                          maxlength="30" name="passwordCtrl" [class.is-invalid]="!isPasswordValid1()"
                          [ngModel]="personalInformation()?.password" (ngModelChange)="
                            updatePersonalInformation({ password: $event }, 'password')
                          " type="{{ hidePassword ? 'password' : 'text' }}" />
                        <button mat-button matSuffix type="button" (click)="hidePassword = !hidePassword"
                          class="eye-icon-button"
                          [attr.aria-label]="'Toggle ' + (hidePassword ? 'visibility' : 'hide')">
                          @if (hidePassword) {
                          <span class="material-symbols-outlined text-muted">
                            visibility
                          </span>
                          } @else {
                          <span class="material-symbols-outlined text-muted">
                            visibility_off
                          </span>
                          }
                        </button>
                      </mat-form-field>

                      <div class="d-flex row row-cols-2" [ngClass]="
                          isPasswordValid1() ? 'valid-feedback' : 'invalid-feedback'
                        ">
                        @for (condition of passwordConditions; track condition) {
                        <div class="col" [ngClass]="condition.valid() ? 'text-success' : 'text-danger'">
                          <i class="fas" [ngClass]="condition.valid() ? 'fa-check' : 'fa-xmark'"></i>
                          {{ condition.label }}
                        </div>
                        }
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row form-row">
                  <!-- How did you hear about us? -->
                  <div class="col-md-6 {{ selectedReferralSourceInfo()?.hasAdditionalInfo ? 'pb-5' : ''}}">
                    <mat-form-field class="w-100"
                      [class.is-invalid]="!personalInformationValidations.get('referralSource')?.()?.valid">
                      <mat-label>* How did you hear about us?</mat-label>
                      <mat-select [(value)]="selectedReferralSource" (openedChange)="onSelectReferralSource()"
                        (selectionChange)="updatePersonalInformation({referralSource: $event.value?.toString()}, 'referralSource')">
                        @for (source of referralSource; track $index) {
                        <mat-option [value]="source.id">{{ source.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (!personalInformationValidations.get('referralSource')?.()?.valid) {
                    @for (error of personalInformationValidations.get('referralSource')?.()?.error; track $index) {
                    <div class="invalid-feedback">
                      <i class="fas fa-xmark"></i>
                      {{error}}
                    </div>
                    }
                    }
                  </div>

                  @if (selectedReferralSourceInfo()?.hasAdditionalInfo) {
                  <div class="col-md-6 animated fadeIn">
                    <div class="form-floating">
                      <input placeholder type="text" class="form-control" name="advertisementCtrl"
                        [class.is-invalid]="!personalInformationValidations.get('additionalInfo')?.()?.valid"
                        [ngModel]="personalInformation()?.additionalInfo"
                        (blur)="validatePersonalInfoField('additionalInfo', $event)"
                        (ngModelChange)="updatePersonalInformation({additionalInfo: $event }, 'additionalInfo')" />
                      <label for="advertisementCtrl">* Tell us more - where did you find us?</label>
                      @if (!personalInformationValidations.get('additionalInfo')?.()?.valid) {
                      @for (error of personalInformationValidations.get('additionalInfo')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                  }
                </div>
                <div class="row form-row">
                  <div class="col-12 mt-3 mb-2 pt-3">
                    <mat-slide-toggle [(ngModel)]="isCheckedAddAnotherContact" name="isCheckedAddAnotherContact"
                      (change)="anotherAccountSlideChanged($event.checked)"> I
                      want to add another contact person to my account
                    </mat-slide-toggle>
                    <ng-container *ngIf="isCheckedAddAnotherContact()">
                      <div class="row row-cols-2 mt-3 pt-3 animated fadeIn">
                        <div class="col mb-2">
                          <div class="form-floating">
                            <input placeholder type="text" class="form-control" name="firstNameContactCtrl"
                              [class.is-invalid]="!personalInformationValidations.get('contactFirstName')?.()?.valid"
                              [ngModel]="personalInformation()?.contactPerson?.firstName"
                              (blur)="validatePersonalInfoField('contactFirstName', $event)"
                              (ngModelChange)="updatePersonalInformation({ firstName: $event }, 'contactFirstName', true)" />
                            <label for="firstNameContactCtrl">First Name</label>
                            @if (!personalInformationValidations.get('contactFirstName')?.()?.valid) {
                            @for (error of personalInformationValidations.get('contactFirstName')?.()?.error; track
                            $index) {
                            <div class="invalid-feedback">
                              <i class="fas fa-xmark"></i>
                              {{error}}
                            </div>
                            }
                            }
                          </div>
                        </div>
                        <div class="col mb-2">
                          <div class="form-floating">
                            <input placeholder type="text" class="form-control" name="lastNameContactCtrl"
                              [class.is-invalid]="!personalInformationValidations.get('contactLastName')?.()?.valid"
                              [ngModel]="personalInformation()?.contactPerson?.lastName"
                              (blur)="validatePersonalInfoField('contactLastName', $event)"
                              (ngModelChange)="updatePersonalInformation({ lastName: $event }, 'contactLastName', true)" />
                            <label for="lastNameContactCtrl">Last Name</label>
                            @if (!personalInformationValidations.get('contactLastName')?.()?.valid) {
                            @for (error of personalInformationValidations.get('contactLastName')?.()?.error; track
                            $index)
                            {
                            <div class="invalid-feedback">
                              <i class="fas fa-xmark"></i>
                              {{error}}
                            </div>
                            }
                            }
                          </div>
                        </div>
                        <div class="col mt-4 mb-4">
                          <div class="form-floating">
                            <input placeholder type="email" class="form-control" name="emailContactCtrl"
                              [class.is-invalid]="!personalInformationValidations.get('contactEmail')?.()?.valid"
                              [ngModel]="personalInformation()?.contactPerson?.email"
                              (blur)="validatePersonalInfoField('contactEmail', $event)"
                              (ngModelChange)="updatePersonalInformation({ email: $event }, 'contactEmail', true)" />
                            <label for="emailContactCtrl">Email</label>
                            @if (!personalInformationValidations.get('contactEmail')?.()?.valid) {
                            @for (error of personalInformationValidations.get('contactEmail')?.()?.error; track $index)
                            {
                            <div class="invalid-feedback">
                              <i class="fas fa-xmark"></i>
                              {{error}}
                            </div>
                            }
                            }
                          </div>
                        </div>
                        <div class="col mt-4 mb-4">
                          <div class="form-floating">
                            <input placeholder type="text" class="form-control" maxlength="10" appOnlyNumber
                              name="phoneContactCtrl"
                              [class.is-invalid]="!personalInformationValidations.get('contactPhone')?.()?.valid"
                              (blur)="validatePersonalInfoField('contactPhone', $event)"
                              [ngModel]="personalInformation()?.contactPerson?.phone"
                              (ngModelChange)="updatePersonalInformation({ phone: $event }, 'contactPhone', true)" />
                            <label for="phoneContactCtrl">Phone</label>
                            @if (!personalInformationValidations.get('contactPhone')?.()?.valid) {
                            @for (error of personalInformationValidations.get('contactPhone')?.()?.error; track $index)
                            {
                            <div class="invalid-feedback">
                              <i class="fas fa-xmark"></i>
                              {{error}}
                            </div>
                            }
                            }
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="row form-row">
                  <div class="col-md-3">
                    <div class="form-floating">
                      <mat-checkbox [checked]="checkboxValues[0]"
                        (change)="updateCheckboxValue($event.checked, 0)">Receive SMS messages</mat-checkbox>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-floating">
                      <mat-checkbox [checked]="checkboxValues[1]"
                        (change)="updateCheckboxValue($event.checked, 1)">Receive information on our latest product
                        offerings, events and local impact</mat-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-row-action">
                  <button type="button" class="btn btn-primary"
                    [disabled]="shouldDisableCreateClientButton() || !firstStep.completed" (click)="createNewClient()">
                    Continue
                  </button>
                </div>

              </form>
            </div>
            }
          </mat-step>

          <mat-step #thirdStep [editable]="false" [completed]="false" label="Payment Method">
            <app-payment-method-signup (out_paymentMethod)="paymentMethod.set($event)"
              (out_isValidFormPaymentMethod)="isValidFormPaymentMethod.set($event)" (out_done)="sendDataToANet()">
            </app-payment-method-signup>
          </mat-step>

          <mat-step #fourthStep [editable]="false" [completed]="false" label="Welcome!">
            <app-welcome [products]="signupProducts()"></app-welcome>
          </mat-step>

        </mat-stepper>
      </div>
    </div>
  </div>

  <app-faqs class="animated fadeInUp" [step]="matStepper().selectedIndex"></app-faqs>
  <app-footer class="animated fadeInUp"></app-footer>
</section>